import { render } from "./HeaderMenuItem.vue?vue&type=template&id=52d67462&scoped=true&lang=pug"
import script from "./HeaderMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenuItem.vue?vue&type=style&index=0&id=52d67462&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d67462"]])

export default __exports__